export const rootPath = '/networking';
export const toolsPath = `${rootPath}/tools`;
export const buildingToolsPath = `${toolsPath}/building_configs`;
export const nasesPath = `${toolsPath}/nases`;
export const complexToolsPath = `${toolsPath}/complex_configs`;
export const tenantRadiusSearchPath = `${rootPath}/tenant_radius`;
export const vlanPath = `${rootPath}/vlans`;
export const equipmentPath = `${rootPath}/equipment`;

export function getNasBoardPath(nasIds) {
  if (!nasIds || !nasIds.length) return nasesPath;
  const searchParams = new URLSearchParams();
  nasIds.forEach((id) => searchParams.append('nas_id', id));
  return `${nasesPath}?${searchParams.toString()}`;
}

export function getBuildingToolsPath(buildingIds) {
  if (!buildingIds || !buildingIds.length) return buildingToolsPath;
  const searchParams = new URLSearchParams();
  buildingIds.forEach((id) => searchParams.append('building_id', id));
  return `${buildingToolsPath}?${searchParams.toString()}`;
}

export function getComplexToolsPath(complexIds) {
  if (!complexIds || !complexIds.length) return complexToolsPath;
  const searchParams = new URLSearchParams();
  complexIds.forEach((id) => searchParams.append('complex_id', id));
  return `${complexToolsPath}?${searchParams.toString()}`;
}

export function getTenantRadiusSearchPath(filters) {
  const searchParams = new URLSearchParams();

  if (filters.attribute) searchParams.append('attribute', filters.attribute);
  if (filters.username) searchParams.append('username', filters.username);
  if (filters.tenant_id) searchParams.append('tenant_id', filters.tenant_id);
  else if (filters.building_id) searchParams.append('building_id', filters.building_id);
  else if (filters.nas_id) searchParams.append('nas_id', filters.nas_id);
  return `${tenantRadiusSearchPath}?${searchParams.toString()}`;
}

export function getVlanManagementPath(buildingId) {
  if (!buildingId) return vlanPath;
  const searchParams = new URLSearchParams();
  searchParams.append('building_id', buildingId);
  return `${vlanPath}?${searchParams.toString()}`;
}
